/* eslint-disable react/prop-types */
import React, { useState } from "react";

import { Modal, ModalContent, ModalHeader, ModalBody } from "@nextui-org/modal";
import { Button } from "@nextui-org/button";
import { Textarea } from "@nextui-org/input";
import AdjustAmountForm from "./AdjustAmountForm";

const RejectSubTicketModal = ({
  isOpen,
  onOpenChange,
  onConfirm,
  adjustAmount = {
    isAdjustable: true,
    defaultAmount: null,
  },
}) => {
  const [rejectReason, setRejectReason] = useState("");
  const [claimAmount, setClaimAmount] = useState(adjustAmount.defaultAmount);
  const [errors, setErrors] = useState({
    reason: false,
    amount: false,
  });

  const validate = () => {
    const newErrors = {
      reason: rejectReason.trim() === "",
      amount:
        adjustAmount.isAdjustable &&
        (claimAmount === null || claimAmount === undefined),
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const handleRejectReasonChange = (e) => {
    setRejectReason(e.target.value);
    setErrors({ ...errors, reason: false });
  };

  const handleConfirm = () => {
    if (validate()) {
      onConfirm({
        rejectReason,
        claimAmount: adjustAmount.isAdjustable ? claimAmount : null,
      });
      setRejectReason("");
      setClaimAmount(adjustAmount.defaultAmount);
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        placement="center"
        onOpenChange={onOpenChange}
        size="2xl"
        closeButton={
          <svg
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: "absolute",
              right: "16px",
              top: "14px",
              background: "transparent",
            }}
          >
            <path
              d="M6 18L18 6M6 6L18 18"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="bg-error text-white">
                ปฏิเสธการอนุมัติคำขอย่อย
              </ModalHeader>
              <ModalBody className="flex flex-col gap-y-7 justify-center py-6 px-3 mx-5">
                {adjustAmount.isAdjustable && (
                  <AdjustAmountForm
                    proposalAmount={adjustAmount.proposalAmount}
                    isAdjustAble
                    onChangeClaimAmount={(amount) => {
                      setClaimAmount(amount);
                      setErrors({ ...errors, amount: false });
                    }}
                    isError={errors.amount}
                  />
                )}
                <Textarea
                  variant="bordered"
                  placeholder="โปรดใส่เหตุผล..."
                  onChange={handleRejectReasonChange}
                  isInvalid={errors.reason}
                />
                <div className="flex flex-row gap-x-10">
                  <Button
                    className="bg-error text-white  w-full"
                    onPress={handleConfirm}
                  >
                    ปฏิเสธคำขอย่อย
                  </Button>
                  <Button
                    className="bg-light-gray-300 text-white  w-full"
                    variant="light"
                    onPress={onClose}
                  >
                    ยกเลิก
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default RejectSubTicketModal;
